import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { I18n } from 'react-redux-i18n';

import { isBrowser } from 'Helpers/Browser';

import Spinner from 'Components/layout/Spinner';
import Button from 'Components/layout/Button';

export default class StickyBar extends React.Component {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        items: PropTypes.array,
        isBrand: PropTypes.bool.isRequired,
        totalPrice: PropTypes.number.isRequired,
        creditsPrice: PropTypes.number.isRequired,
        onCheckout: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired
    };
    static defaultProps = {
        selectedPackageId: ''
    };

    state = {
        visible: false,
        elementClass: ''
    };

    componentDidMount = () => {
        window.addEventListener('scroll', this.trackScroll);
    }

    componentWillUnmount = () => {
        window.removeEventListener('scroll', this.trackScroll);
    }

    componentDidUpdate = () => {
        this.trackScroll();
    }

    trackScroll = () => {
        if (document.querySelector('#btn-checkout')) {
            const btnOffestTop = document.querySelector('#btn-checkout').getBoundingClientRect().top + window.scrollY;
            const windowHeight = screen.height;
            const scrollTop = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);

            if ((windowHeight + scrollTop) > btnOffestTop) {
                this.hide();
            } else {
                this.show();
            }
        }
    }

    show = () => {
        if (!this.state.visible) {
            this.setState({
                ...this.state,
                visible: true,
                elementClass: 'fadeInUp'
            });
        }
    }

    hide = () => {
        if (this.state.visible) {
            this.setState({
                ...this.state,
                visible: false,
                elementClass: 'fadeOutDown'
            });
        }
    }

    renderCreditsBar = () => {
        const { creditsPrice, items } = this.props;

        return (
            <div className={`credits-bar`}>
                <div className="price-info">
                    <span className="price">
                        {creditsPrice} Credits
                    </span>
                    <span className="sub-info">
                        {items.length} Photos
                    </span>
                </div>
                <div className="cta">
                    <Button
                        element="anchor"
                        layout="full-width"
                        className="submit-btn"
                        onClick={this.props.onSubmit}
                    >
                        Buy and Pay with credits
                    </Button>
                </div>
            </div>
        );
    }

    renderPriceBar = () => {
        const { totalPrice, items } = this.props;

        return (
            <div className={`price-bar`}>
                <div className="price-info">
                    <span className="price">
                        <small>$</small> {totalPrice.toFixed(2)}
                    </span>
                    <span className="sub-info">
                        {items.length} Photos
                    </span>
                </div>
                <div className="cta">
                    <Button
                        element="anchor"
                        layout="full-width"
                        className="submit-btn"
                        onClick={this.props.onCheckout}
                    >
                        Proceed to checkout
                    </Button>
                </div>
            </div>
        );
    }

    renderMixedBar = () => {
        const { totalPrice, creditsPrice } = this.props;

        return (
            <div className={`mixed-bar`}>
                <div className="price-info">
                    <span className="price">
                        <small>$</small> {totalPrice.toFixed(2)}
                    </span>
                    <span className="sub-info">
                        + {creditsPrice} Credits
                    </span>
                </div>
                <div className="cta">
                    <Button
                        element="anchor"
                        layout="full-width"
                        className="submit-btn"
                        onClick={this.props.onCheckout}
                    >
                        Proceed to checkout
                    </Button>
                </div>
            </div>
        );
    }

    render() {
        const { isLoading, totalPrice, creditsPrice, isBrand } = this.props;

        if ((!totalPrice && !creditsPrice) || isLoading) {
            return (null);
        }

        let markup = null;
        if (isBrand) {
            markup = this.renderCreditsBar();
        } else {
            if (creditsPrice > 0 && totalPrice > 0) {
                markup = this.renderMixedBar();
            } else if (creditsPrice > 0 && totalPrice === 0) {
                markup = this.renderCreditsBar();
            } else {
                markup = this.renderPriceBar();
            }
        }

        return (
            <div className={`component-cart-sticky-bar animated ${this.state.elementClass}`}>
                {markup}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/cart/StickyBar/index.js